import { render, staticRenderFns } from "./CognitiveDCGJ.vue?vue&type=template&id=15f82043&scoped=true"
import script from "./CognitiveDCGJ.vue?vue&type=script&lang=js"
export * from "./CognitiveDCGJ.vue?vue&type=script&lang=js"
import style0 from "./CognitiveDCGJ.vue?vue&type=style&index=0&id=15f82043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f82043",
  null
  
)

export default component.exports